import React, { type ComponentType } from 'react';

import Loadable from 'react-loadable';

import type { NewCoreIconProps } from '@atlaskit/icon/types';
import type { Dialogues } from '@atlassian/conversation-assistant-service-api/types/assistance-service';
import { HandleActionType } from '@atlassian/rovo-conversation-actions/types';

import type { ConversationActionWithAssistantMetadata } from '../active-action/action-capabilities';
import { TAGS } from '../chat-store/types';

import { INSIGHT_ACTION_ID_PREFIX, type OpenInsight } from './insight-action';

const InsightChatView = Loadable({
	loader: () =>
		import(
			/* webpackChunkName: "@atlassian/conversation-assistant-insight-chat-view" */
			'../../ui/chat-history/insight-chat-view/InsightChatView'
		).then((m) => m.InsightChatView),
	loading: () => null,
});

export const insightToConversationAction = (
	insight: OpenInsight,
	icon: ComponentType<NewCoreIconProps>,
	lifecycle: {
		onDismiss: () => void;
		onCreated: (conversationId: string) => void;
	},
): ConversationActionWithAssistantMetadata => {
	const InsightIcon = icon;
	const { agentMessageAdf, title, followUps } = insight;

	return {
		id: `${INSIGHT_ACTION_ID_PREFIX}:${crypto.randomUUID()}`,
		title,
		followUps,
		presentation: {
			hideActionHeader: true,
			suppressPromptLibrary: true,
			centerInFullScreen: true,
		},
		seededConversation: {
			name: title,
			followUpSource: 'insightsFeed',
			tags: [TAGS.INSIGHTS],
			skipNextFetch: true,
			onCreated: lifecycle.onCreated,
		},
		onDismiss: lifecycle.onDismiss,
		handleType: HandleActionType.Base,
		icon: () => <InsightIcon label={title} />,
		viewConfig: {
			render: () => <InsightChatView agentMessageAdf={agentMessageAdf} />,
		},
		customFollowUpContext: {
			available: true,
			fetch: async (): Promise<Dialogues[]> => [
				{
					human_message: { content: '' },
					agent_message: { content: agentMessageAdf, mimeType: 'text/adf' },
				},
			],
		},
	};
};
